<template>
  <div class="container bottom">
    <div class="mid-container">
      <!--<img src="../img/ic_arrow_up.svg"></img>-->
      <p>Click on the route to add your own pep talks</p>
    </div>
  </div>
</template>

<script>

import BottomNav from './BottomNav'

export default {

  name: 'map',
  title: 'Runner - Map',
  data() {
    return {

    }
  },
  components: {
    BottomNav
  },
  methods: {
    previousPage() {
     this.$router.replace('newrace')
    },
    nextPage() {
      console.log("New page next")
      this.$router.replace('information')
    },
  },
}

</script>

<style lang="scss" scoped>
  @import '../styles/styles.scss';

  .container {
    justify-content: flex-end;
    height: auto;
  }

  .mid-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    flex: 1;
    height: 60px;

    img {
      height: 25px;
      width: 25px;
    }

    p {
      margin: 5px 0px 0px 0px;
      font-size: $font-semiSemiLarge;
    }
  }

  @media screen and (max-width: 1140px) {

    .map-container {
    	bottom: 120px;
    }

    /*.mid-container {
      height: 60px;
    }

    .container {
      justify-content: flex-end;
      height: auto;
    }*/

  }


  @media screen and (min-width: 1140px) {
    .container.bottom {
      width: 45vw;
      height: auto;
      //height: 15vh;
    }

    .mid-container {
      height: 70px;
    }

    img {
      height: 30px;
      width: 30px;
    }

  /*  .mid-container {
      height: 60px !important;
    }*/
  }


</style>
